// One capitalisation style for screen LABELS (form labels, table headers,
// buttons, tabs, section headings, menu items). Never for data: partner
// names, product names, addresses, document names, free text, numbers.
//
//   up to 4 words  -> Title Case, minor words (of, and, for ...) stay small
//   5 words or more -> sentence case (first letter only)
//   abbreviations   -> capitals ("vat code" -> "VAT Code")
//   a word that already has capitals inside it (eBay, McDonald, HMS Bergbau)
//   is left exactly as written.
import { ACRONYM_SET } from './smartCaseAcronyms';

export const TITLE_CASE_MAX_WORDS = 4;

const MINOR = new Set(['a', 'an', 'and', 'as', 'at', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'vs']);
const WORD = /[A-Za-z][A-Za-z0-9'’]*/g;

const capFirst = (w) => w.charAt(0).toUpperCase() + w.slice(1);
const hasInnerCapital = (w) => /[A-Z]/.test(w.slice(1));

const fixWord = (w, { title, first, last }) => {
  if (ACRONYM_SET.has(w.toUpperCase())) return w.toUpperCase();
  if (hasInnerCapital(w)) return w;
  if (first) return capFirst(w);
  if (!title) return w;
  if (MINOR.has(w.toLowerCase()) && !last) return w.toLowerCase();
  return capFirst(w);
};

export function smartCase(text) {
  if (typeof text !== 'string') return text;
  // Emails, links and strings with no letters are data, not labels.
  if (!/[A-Za-z]/.test(text) || /@|:\/\//.test(text)) return text;

  const parts = text.split(/(\s+)/);
  const wordParts = parts.filter((p) => /[A-Za-z]/.test(p));
  const title = wordParts.length <= TITLE_CASE_MAX_WORDS;

  let seen = 0;
  return parts
    .map((part) => {
      if (!/[A-Za-z]/.test(part)) return part;
      const first = seen === 0;
      const last = seen === wordParts.length - 1;
      seen += 1;
      let inner = 0;
      return part.replace(WORD, (w, offset) => {
        // After a slash a new word starts ("buyer/seller"); after a hyphen it does not.
        // "2nd", "24h": letters glued to a number are part of that number.
        if (/\d/.test(part[offset - 1] || '')) { inner += 1; return w; }
        const firstInPart = inner === 0;
        const startsWord = firstInPart || part[offset - 1] === '/';
        inner += 1;
        return startsWord ? fixWord(w, { title, first: first && firstInPart, last }) : w;
      });
    })
    .join('');
}

// For component children: only a plain string is a label we can restyle;
// anything else (icons, counts, nested elements) passes through untouched.
export const smartCaseNode = (node) => (typeof node === 'string' ? smartCase(node) : node);

export default smartCase;
